import { Reveal } from "@/components/motion/Reveal";

// Icon card used in icon grids (Market Entry, R&D and CRO).
export const IconCard = ({ icon: Icon, title, body, i = 0, testId }) => (
  <Reveal delay={i * 0.06} className="group relative border border-line bg-surface p-7 transition-colors duration-300 hover:border-accent hover:bg-accent-soft sm:p-8" data-testid={testId}>
    <div className="flex items-start justify-between">
      <Icon className="h-7 w-7 text-accent" strokeWidth={1.5} />
      <span className="font-mono text-[12px] text-muted">{String(i + 1).padStart(2, "0")}</span>
    </div>
    <h3 className="mt-10 font-display text-[1.45rem] font-semibold leading-tight tracking-[-0.025em] text-ink">{title}</h3>
    <p className="mt-3 text-[15px] leading-relaxed text-muted">{body}</p>
  </Reveal>
);

const COLS = { 3: "md:grid-cols-3", 4: "md:grid-cols-2 lg:grid-cols-4" };

// Numbered horizontal step strip.
export const StepStrip = ({ steps = [], testId }) => (
  <ol className={`grid border-y border-line ${COLS[steps.length] || "md:grid-cols-3"}`} data-testid={testId}>
    {steps.map((s, i) => (
      <li key={s} className={`flex items-center gap-4 py-6 md:px-6 ${i ? "border-t border-line md:border-t-0 md:border-l" : "md:pl-0"} ${steps.length === 4 && i === 2 ? "md:border-l-0 md:pl-0 lg:border-l lg:pl-6" : ""} ${steps.length === 4 && i > 1 ? "md:border-t lg:border-t-0" : ""}`}>
        <span className="grid h-10 w-10 shrink-0 place-items-center border border-accent font-mono text-[13px] text-accent">{String(i + 1).padStart(2, "0")}</span>
        <span className="text-[15px] font-medium text-ink">{s}</span>
      </li>
    ))}
  </ol>
);
